import '../style.css';

export function FH1Grade(props) {
  const { 'title': _, ...props0 } = props;
  return <div {...props0} className={`fh1-grade ${props.className ?? ''}`}>
    <div className='fh1-title'>{props.title}</div>
    <div className='fh1-content'>
      {props.children}
    </div>
  </div>;
}
